import { cn } from "@/lib/utils";
import logoImg from "@/assets/logo.webp";

/**
 * Official brand logo for Summit Neighbor Fencing Co.
 * The artwork already contains the wordmark, so text is off by default.
 */
export const LogoMark = ({ className }: { className?: string }) => (
  <img
    src={logoImg}
    alt="Summit Neighbor Fencing Co. logo"
    className={cn("object-contain", className)}
    loading="eager"
    decoding="async"
  />
);

interface LogoProps {
  className?: string;
  markClassName?: string;
  tone?: "dark" | "light";
  showText?: boolean;
}

const Logo = ({ className, markClassName, tone = "dark", showText = false }: LogoProps) => {
  const primaryText = tone === "light" ? "text-white" : "text-foreground";
  const subText = tone === "light" ? "text-white/70" : "text-muted-foreground";

  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <LogoMark className={cn("h-16 sm:h-[4.5rem] w-auto shrink-0", markClassName)} />
      {showText && (
        <span className="flex flex-col leading-none">
          <span className={cn("font-heading font-extrabold tracking-tight text-[1.02rem] sm:text-[1.08rem]", primaryText)}>
            Summit Neighbor
          </span>
          <span className={cn("font-heading font-semibold uppercase tracking-[0.26em] text-[0.58rem] mt-1", subText)}>
            Fencing Co.
          </span>
        </span>
      )}
    </span>
  );
};

export default Logo;
